import {clsx} from 'external/clsx'
import {useMemo, FC} from 'external/react'

import { Course } from '../../types/course'

import Switch from 'components/Switch'
import LabeledValue from 'components/LabeledValue'

import usePayment from 'context/payment-context/hook'

type PackageWorkbookSwitchProps = {
    course: Course
}

const PackageWorkbookSwitch : FC<PackageWorkbookSwitchProps> = props => {
    const {course} = props
    const {courseId, workbookPrice} = course
    const { cart, toggleWorkbook} = usePayment()
    const checked = useMemo(() => cart.properties.workbooks && cart.properties.workbooks[courseId] , [courseId, cart.properties.workbooks])
    
    return (
       <div className={clsx('d-flex', 'flex-direction-column')}>
            <Switch defaultChecked={checked} style={{paddingLeft: '10pc'}} onChange={(e) => toggleWorkbook(courseId, e.target.checked)}>
                <LabeledValue className='d-inline ml-1' style={{cursor: 'default'}} value={`Añadir cuaderno de trabajo ($ ${workbookPrice})`} />
            </Switch>
       </div>
   )
}

export {PackageWorkbookSwitch as default}